'use client'

import { Analytics } from '@vercel/analytics/next'
import { sanitizeVercelAnalyticsEvent } from '@/lib/telemetryUrlSanitizer'

/**
 * Vercel Web Analytics with the same URL redaction as PostHog and Sentry: its
 * Next adapter sends the raw pathname as the pageview, which on a support-sent
 * password reset link (/auth/reset/<token>) is a live credential.
 * `beforeSend` is a function, so this lives in a client component; RootShell
 * is rendered on the server.
 */
export function VercelAnalytics() {
  return <Analytics beforeSend={sanitizeVercelAnalyticsEvent} />
}
